import { ProposalSynthesis } from "../../../../gql/hooks";

const getValue = (val: any) => (val ? `${val}` : "");

const getDraftSynthesis = (synthesis: ProposalSynthesis) => ({
  estimatedLiters: getValue(synthesis.estimatedLiters),
  estimatedFreeLiters: getValue(synthesis.estimatedLiters),
  discount: getValue(synthesis.discount),
  rappel: getValue(synthesis.rappel),
  noChargeProducts: getValue(synthesis.noChargeProducts),
  loanImport: getValue(synthesis.loanImport),
  loanLiters: getValue(synthesis.loanLiters),
  loanMonth: getValue(synthesis.loanMonth),
  adsMonth: getValue(synthesis.adsMonth),
  adsImport: getValue(synthesis.adsImport),
  adsLiters: getValue(synthesis.adsLiters),
  marketingSupport: getValue(synthesis.marketingSupport),
  pointOfSaleSupport: getValue(synthesis.pointOfSaleSupport),
  plvSupport: getValue(synthesis.plvSupport),
  specialDecoration: getValue(synthesis.specialDecoration),
  notes: getValue(synthesis.notes),
});

export default getDraftSynthesis;
